<template>
  <b-card>
    <b-card-header>
      <i class="icon-menu mr-1"></i>Log Detail
    </b-card-header>
    <Log :id="$route.params.id" @updated="updated"/>
    <div v-if="uid">
      <h4>User</h4>
      <User :id="uid"/>
    </div>
    <div v-if="deviceId">
      <h4>Device</h4>
      <Device :id="deviceId"/>
    </div>
    <template slot="footer">
      <b-button @click="goBack">Back</b-button>
    </template>
  </b-card>
</template>

<script>
import Log from '../logs/Log'
import User from '../users/User'
import Device from '../devices/Device'

export default {
  name: 'LogDetail',
  components: {
      Log,
      User,
      Device,
  },
  data: function() {
   return {
     uid: null,
     deviceId: null
   } 
  },
  methods: {
    updated(log) {
      if (log.uid) this.uid = log.uid ? log.uid.id ? log.uid.id: log.uid: null;
      if (log.deviceId) this.deviceId = log.deviceId ? log.deviceId.id ? log.deviceId.id: log.deviceId: null;
    },
    goBack() {
      this.$router.go(-1)
    }
  }
}
</script>
